export default __webpack_public_path__ + "99f93cec83e79ade3f78f82a101ea9b3.jpg";